import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    // Apply published updates automatically so fresh job adverts appear after refresh.
    updateSW(true);
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
  onRegistered(registration) {
    // Check regularly for newly published job content.
    if (registration) {
      setInterval(() => {
        registration.update();
      }, 15 * 60 * 1000);
    }
  },
  onRegisterError(error) {
    console.error('SW registration error', error);
  }
});

export { updateSW };
